import { render, staticRenderFns } from "./Reject080Main.vue?vue&type=template&id=261ffe6f&"
import script from "./Reject080Main.vue?vue&type=script&lang=ts&"
export * from "./Reject080Main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports